var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIDistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.78,
    height: 8.78,
    viewBox: "0 0 8.78 8.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-route",
    "data-name": "Icon awesome-route",
    d: "M7.133,5.487H5.487a.549.549,0,0,1,0-1.1H7.133S8.78,2.555,8.78,1.646a1.646,1.646,0,0,0-3.292,0,3.617,3.617,0,0,0,.777,1.646H5.487a1.646,1.646,0,1,0,0,3.292H7.133a.549.549,0,0,1,0,1.1H3.181a11.839,11.839,0,0,1-.811,1.1H7.133a1.646,1.646,0,0,0,0-3.292Zm0-4.39a.549.549,0,1,1-.549.549A.548.548,0,0,1,7.133,1.1ZM1.646,4.39A1.647,1.647,0,0,0,0,6.036C0,6.945,1.646,8.78,1.646,8.78S3.292,6.945,3.292,6.036A1.647,1.647,0,0,0,1.646,4.39Zm0,2.195a.549.549,0,1,1,.549-.549A.548.548,0,0,1,1.646,6.585Z",
    fill: "#909faf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDistance);
export default __webpack_public_path__ + "static/media/i-distance.4c7c4f70838f01a4e20f6ca5cf27a3a5.svg";
export { ForwardRef as ReactComponent };